import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Shared route-scroll seam. Normal pathname navigation opens the destination at the top;
// intentional hash navigation (e.g. /#check-price) scrolls the target element into view.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Defer to next frame so the destination has rendered before we resolve the anchor.
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
        else window.scrollTo(0, 0);
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
